import React from 'react'
import { Row, Col, Card, CardHeader, CardBody, Button, Input, } from 'reactstrap'
import districtAdmin from '../../helpers/users/testing/districtAdmin';
import superAdmin from '../../helpers/users/testing/superAdminUser';
import schoolAdmin from '../../helpers/users/testing/schoolAdmin';
import teacherUser from '../../helpers/users/testing/teacherUser';
import studentUser from '../../helpers/users/testing/studentUser';
import devDeleteUserAssessment from '../../helpers/users/testing/deleteUserAssessment';
import studentUser2 from '../../helpers/users/testing/studentUser2';
import studentUser3 from '../../helpers/users/testing/studentUser3';
import studentUser4 from '../../helpers/users/testing/studentUser4';
import studentUser5 from '../../helpers/users/testing/studentUser5';
import studentUser6 from '../../helpers/users/testing/studentUser6';
import studentUser7 from '../../helpers/users/testing/studentUser7';
import deleteJonesUserAssessments from '../../helpers/users/testing/deleteJonesUserAssessments'
import queryString from 'query-string'
import setAllClassYears from '../../helpers/users/testing/setAllClassYears';
import { db } from '../../config/firebaseconfig';

/* ManageUsersContainer
  <ManageUsers
    isFetchingAllUsers={this.props.isFetchingAllUsers}
    usersList={this.props.usersList}
    error={this.props.error}
    activeUserId={this.props.activeUserId}
    setUserDevOnly={this.props.setUserDevOnly}
    handleChange={this.handleChange}
    handleSubmit={this.handleSubmit}
    testUser={this.props.testUser}
    setTestUser={this.props.setTestUser}
  />
*/

export default function ManageUsers (props) {
  
  let options = <option></option>
  if (props.usersList) {
    options = props.usersList.map( (user, n) => {
      return <option key={'option' + n} value={user.uid}>{user.displayName}</option>
    })
  } 
  
  let selectDropdown = (
    <div>
      <Input type='select' onChange={props.handleChange}>
        <option>{' '}</option>
        {options}
      </Input>
      <Button onClick={props.handleSubmit}>Submit</Button>
    </div>
  )
  selectDropdown = null

  function handleChange(e) {
    if (e.target.value === '') {
      props.setTestUser(districtAdmin)
    } else if (e.target.value === 'Super Administrator') {
      props.setTestUser(superAdmin)
    } else if (e.target.value === 'District Admin') {
      props.setTestUser(districtAdmin)
    } else if (e.target.value === 'School Admin') {
      props.setTestUser(schoolAdmin)
    } else if (e.target.value === 'Teacher') {
      props.setTestUser(teacherUser)
    } else if (e.target.value === 'Student') {
      props.setTestUser(studentUser)
    } else if (e.target.value === 'Student 2') {
      props.setTestUser(studentUser2)
    } else if (e.target.value === 'Student 3') {
      props.setTestUser(studentUser3)
    } else if (e.target.value === 'Student 4') {
      props.setTestUser(studentUser4)
    } else if (e.target.value === 'Student 5') {
      props.setTestUser(studentUser5)
    } else if (e.target.value === 'Student 6') {
      props.setTestUser(studentUser6)
    } else if (e.target.value === 'Student 7') {
      props.setTestUser(studentUser7)
    }
  }

  function updateAllStudentFullNames () {
    db.collection('students').get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          if (doc.exists) {
            const data = doc.data()
            if (!data.fullName) {
              const fullName = `${data.firstName} ${data.lastName}`
              if (data.id) {
                db.collection('students').doc(data.id).update({fullName: fullName})
                  .catch(err => console.log(err))
              }
            }
          }
        })
      })
  }

  

  return  (
    <div>
      <Row>
        <Col>
          <Card>
            <CardHeader>
              Select Active User (Dev Only)
            </CardHeader>
            <CardBody>
              {selectDropdown}
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card>
            <CardHeader>
              Select Role (Dev Only)
            </CardHeader>
            <CardBody>
              <Input type='select' value={props.testUserRole} onChange={(e) => handleChange(e)}>
                <option value=''>Default</option>
                <option value='Super Administrator'>Super Admin</option>
                <option value='District Admin'>District Admin</option>
                <option value='School Admin'>School Admin</option>
                <option value='Teacher'>Teacher</option>
                <option value='Student'>Student</option>
                <option value='Student 2'>Student 2</option>
                <option value='Student 3'>Student 3</option>
                <option value='Student 4'>Student 4</option>
                <option value='Student 5'>Student 5</option>
                <option value='Student 6'>Student 6</option>
                <option value='Student 7'>Student 7</option>
              </Input>
              <Button onClick={() => devDeleteUserAssessment()}>
                Delete UA
              </Button>
              <Button onClick={() => deleteJonesUserAssessments() }>
                Delete Jones
              </Button>
              <Button onClick={() => updateAllStudentFullNames()} >
                Update all student fullnames
              </Button>
              {/* <Button onClick={() => setAllClassYears()}>Set all Class Years</Button> */}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Users/ManageUsers.js